export default "/images/vendor/flag-icon-css/flags/1x1/om.svg?e5b8ab73e47d055889b69ae84c5fcabd";